export enum AutogiroMandateSentEnum {
  Sent = 20,
  NotSent = 10,
}
